import { FlowRateUnits } from "@/libs/units/flowRate";
import { PercentageUnits } from "@/libs/units/percentage";
import {
  getHpsSingleLiquidRateLabel,
  getHpsTotalLiquidRateLabel
} from "@/utils/hpsLiquidType";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderWellTestCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => {
  const hpsLiquidType = scenario.wellProperties.value?.hps_liquid_type;

  return [
    {
      section: "Well Test",
      label: "Test Productivity Index",
      targetUnit: targetUnits.productivityFlowUnit,
      value: calcs.productivityIndexStbdPsia.value,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Well Test",
      label: `${getHpsTotalLiquidRateLabel(hpsLiquidType)} Test Rate`,
      overrideLabel: { newLabel: "bbl/d", labelToReplace: "STB/D" },
      targetUnit: targetUnits.liquidFlowUnit,
      value: calcs.wellTestFlowRates.value.liquidFlowRateSTBD
    },
    {
      section: "Well Test",
      label: "Water Cut",
      targetUnit: PercentageUnits.Percentage,
      value: calcs.wellTestFlowRates.value.waterCutPercentage
    },
    {
      section: "Well Test",
      label: "Oil Test Rate",
      overrideLabel: { newLabel: "bbl/d", labelToReplace: "STB/D" },
      targetUnit: targetUnits.liquidFlowUnit,
      value: scenario.wellProperties.value?.well_test_oil_rate_stb_day
    },
    {
      section: "Well Test",
      label: `${getHpsSingleLiquidRateLabel(hpsLiquidType).replace(
        " Rate",
        " Test Rate"
      )}`,
      overrideLabel: { newLabel: "bbl/d", labelToReplace: "STB/D" },
      targetUnit: targetUnits.liquidFlowUnit,
      value: scenario.wellProperties.value?.well_test_water_rate_stb_day
    },
    {
      section: "Well Test",
      label: "Gas Test Rate",
      targetUnit: targetUnits.gasFlowUnit,
      value: FlowRateUnits.ThousandCubicFeetPerDay.toStandardUnit(
        scenario.wellProperties.value?.well_test_gas_rate_mscf_day
      )
    },
    {
      section: "Well Test",
      label: "Test Gas/Oil Ratio",
      targetUnit: targetUnits.liquidRatioUnit,
      value: calcs.wellTestFlowRates.value.gasOilRatioSCFSTB
    },
    {
      section: "Well Test",
      label: "Test Gas/Liquid Ratio",
      targetUnit: targetUnits.liquidRatioUnit,
      value: calcs.wellTestFlowRates.value.gasLiquidRatioSCFSTB
    },
    {
      section: "Well Test",
      label: "Datum Point (MD)",
      targetUnit: targetUnits.largeLengthUnit,
      value:
        scenario.wellProperties.value
          ?.well_test_datum_point_measured_depth_feet,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Well Test",
      label: "Datum Point (TVD)",
      targetUnit: targetUnits.largeLengthUnit,
      value: calcs.equipmentLengths.datumPointTVD,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Well Test",
      label: "Static Bottomhole Pressure ",
      targetUnit: targetUnits.pressureUnit,
      value:
        scenario.wellProperties.value
          ?.well_test_static_bottom_hole_pressure_psia,
      hidden: !calcs.isScenarioEspShore.value
    },
    {
      section: "Well Test",
      label: "Test Producing Bottomhole Pressure",
      targetUnit: targetUnits.pressureUnit,
      value:
        scenario.wellProperties.value
          ?.well_test_producing_bottom_hole_pressure_psia,
      hidden: !calcs.isScenarioEspShore.value
    }
  ];
};
